export const SHOW_HEADER_LOGO = "SHOW_HEADER_LOGO";
export const HIDE_HEADER_LOGO = "HIDE_HEADER_LOGO";



// WEBPACK FOOTER //
// ./src/services/ui/logo/types.js